module.exports = {"name":"Landing","component":"Landing","clauseCount":3,"clauses":{"tagline":{"en":"Predictive Maintenance for Commercial HVAC","jp":"HVACシステムの予知保全"},"login":{"en":"Login","jp":"ログイン"},"req":{"en":"Request Access","jp":"アクセスをリクエスト"},"more":{"en":"More Info","jp":"詳細情報"}}}


//////////////////
// WEBPACK FOOTER
// ./src/lib/langTemplates/LandingTemplate.json
// module id = 63
// module chunks = 1